/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: OptionsIcon.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  13.03.23 2:27 pm.
 * Last modified: 13.03.23 2:27 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';

const HelpIcon = ({ selected, onClick }: { selected?: boolean; onClick?: () => void }) => {
    return (
        <div onClick={onClick} className={selected ? 'egt_settings_tab_selected' : ''}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85 85" id="settingsHelp">
                <g id="Group_2809" data-name="Group 2809" transform="translate(-1058 -796)">
                    <circle
                        id="Ellipse_3"
                        data-name="Ellipse 3"
                        cx="42.5"
                        cy="42.5"
                        r="42.5"
                        transform="translate(1058 796)"
                        fill="#040404"
                    />
                    <g id="Group_2793" data-name="Group 2793">
                        <path
                            id="Path_4643"
                            data-name="Path 4643"
                            d="M30.352,11.167a14.6,14.6,0,0,0-14.6,14.6h7.3a7.3,7.3,0,1,1,14.6,0c0,7.3-10.951,6.388-10.951,18.252H34c0-8.214,10.951-9.126,10.951-18.252A14.6,14.6,0,0,0,30.352,11.167Z"
                            transform="translate(1069.885 804.833)"
                            className="settingsIcons"
                        />
                        <ellipse
                            id="Ellipse_111"
                            data-name="Ellipse 111"
                            cx="3.982"
                            cy="3.982"
                            rx="3.982"
                            ry="3.982"
                            transform="translate(1096.254 853.035)"
                            className="settingsIcons"
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
};

export default HelpIcon;
